import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErr, fetchAuth } from "../../../store/authSlice";
import { getDashboardPath } from "../../../utils/authRedirect";
import { usePortal } from "../../../context/PortalContext";
import AuthLoginFlow from "../Auth/AuthLoginFlow";
import { PORTAL_PERKS } from "../Auth/portalAuthCopy";
import a from "../Auth/auth.module.css";
import Seo from "../../Seo";

export default function PortalLoginPage({ portal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subdomain, clinic } = usePortal();
  const { err, isAuth, role, load } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuth && role) {
      navigate(getDashboardPath(role), { replace: true });
    }
  }, [isAuth, role, navigate]);

  const submit = ({ login, password }) => {
    dispatch(clearErr());
    dispatch(fetchAuth({ subdomain, login, password }));
  };

  const errorText =
    typeof err === "string" ? err : err?.message || err?.error || null;

  const forgotPath =
    portal.id === "admin"
      ? "/manage/forgot-password"
      : portal.id === "staff"
        ? "/staff/forgot-password"
        : "/forgot-password";

  return (
    <>
      <Seo noindex title={`Вход — ${portal.title}`} />
      <AuthLoginFlow
        heroBadge={clinic?.name}
        perks={PORTAL_PERKS[portal.id]}
        portalId={portal.id}
        backTo={portal.home}
        backLabel="Назад"
        title="Вход"
        subtitle={
          clinic?.name
            ? `Войдите в «${portal.title}» клуба «${clinic.name}».`
            : portal.subtitle
        }
        emailPlaceholder="email@example.com"
        loading={load}
        error={errorText}
        onSubmit={submit}
        footer={
          <div className={a.footerLinksModern}>
            <Link to={forgotPath}>Забыли пароль?</Link>
            {portal.id === "patient" ? (
              <Link to={portal.register}>Нет аккаунта? Зарегистрироваться</Link>
            ) : null}
          </div>
        }
      />
    </>
  );
}
